import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from './directives/directives.module';
import { FormFieldsModule } from './components/form-fields/form-fields.module';
import { InlineFieldsModule } from './components/inline-fields/inline-fields.module';
import { PipesModule } from './pipes/pipes.module';
import { ModalsModule } from './modals/modals.module';
import { WidgetsModule } from './components/widgets/widgets.module';
import { ChartModule } from './components/chart/chart.module';
import { SavedViewsModule } from './modules/saved-views/saved-views.module';
import { OrganismModule } from './components/organism/organism.module';
import { ParcelMapModule } from './components/parcel-map/parcel-map.module';
import { ConfirmService } from './components/widgets/dialog/confirm/confirm.service';
import { OverlayModule } from '@angular/cdk/overlay';
import { AddLinkToCustomObjectValueModule } from '@shared/components/add-link-to-custom-object-value/add-link-to-custom-object-value.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    FormFieldsModule,
    InlineFieldsModule,
    FormFieldsModule,
    PipesModule,
    ModalsModule,
    WidgetsModule,
    ChartModule,
    SavedViewsModule,
    OverlayModule,
    AddLinkToCustomObjectValueModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    FormFieldsModule,
    InlineFieldsModule,
    PipesModule,
    ModalsModule,
    WidgetsModule,
    ChartModule,
    OrganismModule,
    SavedViewsModule,
    ParcelMapModule,
  ],
  declarations: [],
  providers: [ConfirmService],
})
export class SharedModule {}
